import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  FormControl,
  ControlLabel,
  Table,
  FormGroup,
  Grid,
} from "react-bootstrap";
import Select from "react-select";
import Card from "components/Card/Card";
import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import {
  getAllStoresByCountryCode,
  getRiderDetail,
} from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import moment from "moment";
import { searchMedicationForWID } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import { getWarehouseInventoryDispatchById } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
import { EditWarehouseInventoryDispatchAPI } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";

const EditWarehouseInventoryDispatch = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [rows, setRows] = useState([]);
  const [store, setStore] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [typingTimeOut, setTypingTimeOut] = useState(null);
  const [medicineSearch, setMedicineSearch] = useState(null);
  const [medicationOption, setMedicationOption] = useState([]);
  const [searchMedicineListData, setSearchMedicineListData] = useState([]);
  const [getDeliveryType, setGetDeliveryType] = useState("");
  const [getRiderDetails, setGetRiderDetails] = useState([]);
  const [status, setStatus] = useState();
  const [dispatchedDate, setDispatchedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  useEffect(() => {
    fetchAllRider();
    fetchAllStores();
    getWarehouseDispatchById(props.match.params.id);
  }, []);
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        selectedOption: null,
        qty: "1",
      },
    ]);
  };
  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setStoreOptions(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };
  const fetchAllRider = async () => {
    try {
      const response = await getRiderDetail(obj);
      const riders = response.data.data.map((riders) => {
        return {
          value: riders.id,
          label: riders.name,
        };
      });
      setGetRiderDetails(riders || []);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  const getWarehouseDispatchById = async (id) => {
    try {
      const response = await getWarehouseInventoryDispatchById(id, obj);
      const data = response.data;
      setStore({ value: data.store.id, label: data.store.name });
      setStatus(data.status);
      setDispatchedDate(data.dispatched_date);
      setGetDeliveryType(data.delivery_type);
      setRows(
        data.dispatch_items.map((medication) => ({
          selectedOption: {
            value: medication.id,
            label: `${medication.name} (${medication.item_code})`,
          },
          qty: medication.quantity || "1",
          availableQty: medication.total_quantity - medication.total_allocated,
        }))
      );
    } catch (error) {
      console.log("Error fetching warehouse dispatch data:", error);
      _notificationSystem.current.addNotification({
        message: "Failed to fetch warehouse dispatch data.",
        level: "error",
      });
    }
  };
  const handleInputChange = (inputValue) => {
    const val = inputValue;
    setMedicineSearch(val);

    if (typingTimeOut) {
      clearTimeout(typingTimeOut);
    }
    if (val.trim() !== "" && val.length > 2) {
      setTypingTimeOut(
        setTimeout(function () {
          sendToParent(medicineSearch);
        }, 500)
      );
    } else {
      setMedicationOption([]);
      setSearchMedicineListData([]);
    }
  };

  const sendToParent = async (val) => {
    const res = await searchMedicationForWID(val, obj);

    const medicationOption = res.data.data.map((item) => {
      return {
        value: item.id,
        label: item.title,
      };
    });
    setMedicationOption(medicationOption);
    setSearchMedicineListData(res.data.data);
  };

  const handleSelectChange = (selectedOption, index) => {
    const updatedRows = [...rows];
    updatedRows[index].selectedOption = selectedOption;
    setRows(updatedRows);
  };

  const handleDispatchedDate = (value) => {
    const selectedDate = moment(value).format("YYYY-MM-DD");
    setDispatchedDate(selectedDate);
  };

  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }
  };

  const handleQtyChange = (e, index) => {
    const updatedRows = [...rows];
    const value = parseInt(e.target.value, 10) || 1;
    updatedRows[index].qty = value;
    setRows(updatedRows);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };
  const onSubmit = async () => {
    let errors = [];
    if (rows.length === 0) {
      _notificationSystem.current.addNotification({
        message: "Please add at least one medication.",
        level: "error",
      });
      return;
    }

    if (!dispatchedDate) {
      _notificationSystem.current.addNotification({
        message: "Please select a dispatched date.",
        level: "error",
      });
      return;
    }

    if (errors.length > 0) {
      errors.forEach((msg) => {
        _notificationSystem.current.addNotification({
          message: msg,
          level: "error",
        });
      });
      return;
    }
    const id = props.match.params.id || null;
    const data = {
      store_id: store ? store.value : null,
      dispatch_date: dispatchedDate,
      status: status,
      dispatch_by: token.id,
      medications: rows.map((row) => ({
        medication_id: row.selectedOption ? row.selectedOption.value : null,
        quantity: row.qty,
      })),
      purchase_request_id: parseInt(id),
    };
    const res = await EditWarehouseInventoryDispatchAPI(data, id, obj);
    if (!!res.data.success) {
      _notificationSystem.current.addNotification({
        message: "Warehouse Inventory Dispatch submitted successfully!",
        level: "success",
      });

      setTimeout(() => {
        props.history.push("/admin/warehouse-inventory-dispatch");
      }, 2000);
    } else {
      _notificationSystem.current.addNotification({
        message: "Failed to submit Warehouse Inventory Dispatch.",
        level: "error",
      });
      setRows([]);
      setStore([]);
      setDispatchedDate(moment().format("YYYY-MM-DD"));
      setMedicineSearch(null);
      setMedicationOption([]);
      setSearchMedicineListData([]);
    }
  };

  const disablePastDt = (current) => {
    const yesterday = moment().subtract(1, "day");
    return current.isAfter(yesterday);
  };
  return (
    <div className="add-warehouse-inventory-dispatch">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Col md={8}>
          <Card
            content={
              <div
                style={{
                  marginBottom: "40px",
                  padding: "0 20px",
                }}
              >
                <Col md={12}>
                  <Row>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Store</ControlLabel>
                          <Select
                            options={storeOptions}
                            onChange={(selectedOption) => {
                              setStore(selectedOption);
                            }}
                            placeholder="Select Store"
                            value={store}
                            isDisabled={true}
                          />
                          {/* {requestDateError} */}
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="fl_datepicker">
                        <div className="payment_duePicker">
                          <ControlLabel>Dispatched Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            defaultValue={new Date()}
                            isValidDate={disablePastDt}
                            closeOnSelect={true}
                            value={dispatchedDate}
                            onChange={handleDispatchedDate}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <br />
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Medicine Name</ControlLabel>
                              </th>

                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Available Stock</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}>
                                <ControlLabel>Quantity</ControlLabel>
                              </th>
                              <th style={{ textAlign: "center" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "center",
                                    fontFamily: "sans-serif",
                                  }}
                                >
                                  No medication added
                                </td>
                              </tr>
                            ) : (
                              rows.map((row, index) => (
                                <tr key={index}>
                                  <td style={{ width: "30%" }}>
                                    <Select
                                      placeholder="Search medicine"
                                      isDisabled={status === 3 || status === 4}
                                      value={
                                        row.selectedOption &&
                                        row.selectedOption.label &&
                                        row.selectedOption.value
                                          ? row.selectedOption
                                          : null
                                      }
                                      onChange={(selected) =>
                                        handleSelectChange(selected, index)
                                      }
                                      onInputChange={(inputValue) =>
                                        handleInputChange(inputValue)
                                      }
                                      options={medicationOption}
                                      isClearable
                                      isSearchable
                                      noOptionsMessage={() => "No results"}
                                    />
                                  </td>

                                  <td>
                                    <FormControl
                                      name="availableStock"
                                      value={row.availableQty}
                                      type="text"
                                      placeholder="Available Stock"
                                      isDisabled
                                      readOnly
                                    />
                                  </td>
                                  <td>
                                    <FormControl
                                      disabled={status === 3 || status === 4}
                                      name="qty"
                                      value={row.qty}
                                      type="number"
                                      min="1"
                                      placeholder="Enter Quantity"
                                      onBlur={(e) => handleQtyBlur(e, index)}
                                      onChange={(e) =>
                                        handleQtyChange(e, index)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <a
                                      style={{
                                        pointerEvents:
                                          status === 3 || status === 4
                                            ? "none"
                                            : "auto",
                                        color:
                                          status === 3 || status === 4
                                            ? "gray"
                                            : "blue",
                                      }}
                                      href="javascript:void(0)"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      X
                                    </a>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Row>
                  <Col sm={12}>
                    <Button
                      style={{ marginBottom: "15px" }}
                      onClick={onSubmit}
                      className="fl_btn_add_order btn-fill btn btn-default"
                      fill
                    >
                      Update
                    </Button>{" "}
                  </Col>
                </Row>
              </div>
            }
          />
        </Col>
      </Grid>
    </div>
  );
};
export default EditWarehouseInventoryDispatch;
